var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"detail-back-top "},[(!_vm.isTop)?_c('div',[_c('span',{staticClass:"iconfont",on:{"click":function($event){return _vm.goBackTop()}}},[_vm._v("")])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }